import React from 'react';
type IconProps = {
  className?: string;
};
const base = 'stroke-current';
export function ScissorsIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-112" data-mp="1evam0fj9rsma">
      <circle cx="6" cy="18" r="2.6" data-id="element-113" data-mp="15wp5sr19spoo" />
      <circle cx="18" cy="18" r="2.6" data-id="element-114" data-mp="15xqhmxq41g7g" />
      <path d="M7.6 16.2 19 3M16.4 16.2 5 3" strokeLinecap="round" data-id="element-115" data-mp="15yt8j5nfnind" />
    </svg>;
}
export function FadeIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-116" data-mp="1xmto8k5gz2n9">
      <path d="M3 20h18" strokeLinecap="round" data-id="element-117" data-mp="1jvymdrte1lt6" />
      <path d="M5 16.5h14M6.5 13h11M8 9.5h8M9.5 6h5M11 3h2" strokeLinecap="round" data-id="element-118" data-mp="1ovb8298iwmu6" />
    </svg>;
}
export function RazorIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-119" data-mp="2cj2mpjhjdbym">
      <path d="M3 13.5c3.2 3 6.2 4.5 9 4.5s5.8-1.5 9-4.5" strokeLinecap="round" data-id="element-120" data-mp="xfd1hjoarwvz" />
      <path d="M4.8 11c2.4-2.6 4.8-3.9 7.2-3.9s4.8 1.3 7.2 3.9" strokeLinecap="round" data-id="element-121" data-mp="xdae77ej4huy" />
      <path d="M12 7.1V3.2" strokeLinecap="round" data-id="element-122" data-mp="tfmdfnq5nuv5" />
    </svg>;
}
export function CrownIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-123" data-mp="12dy23k7goiky">
      <path d="M3 8.5 6.5 13 12 5.5 17.5 13 21 8.5v9.5H3V8.5Z" strokeLinejoin="round" data-id="element-124" data-mp="1h2kog5viaalo" />
    </svg>;
}
export function CarIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-125" data-mp="1q3sg453iod6s">
      <path d="M3 15v-2.2L5.2 7h13.6L21 12.8V15" strokeLinejoin="round" data-id="element-126" data-mp="1l4pkfb9ffjbh" />
      <path d="M3 15h18v2.5h-3V15M6 17.5V15" strokeLinejoin="round" data-id="element-127" data-mp="3rvf4dyw0xtzk" />
      <path d="M6.5 11.5h11" strokeLinecap="round" data-id="element-128" data-mp="3rxhvkm8wxt5v" />
    </svg>;
}
export function PhoneIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-129" data-mp="1qtpeao9b9237">
      <path d="M6.2 3.5h3l1.4 3.6-2 1.4a12.5 12.5 0 0 0 6.9 6.9l1.4-2 3.6 1.4v3a2 2 0 0 1-2.2 2C10.9 19 5 13.1 4.2 5.7a2 2 0 0 1 2-2.2Z" strokeLinejoin="round" data-id="element-130" data-mp="1vtbtv4cm2uf6" />
    </svg>;
}
export function PinIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-131" data-mp="29sbkuinljlei">
      <path d="M12 21c4.2-4.4 6.3-7.7 6.3-10.2A6.3 6.3 0 0 0 5.7 10.8C5.7 13.3 7.8 16.6 12 21Z" strokeLinejoin="round" data-id="element-132" data-mp="2eqcz8qa2uwjn" />
      <circle cx="12" cy="10.4" r="2.3" data-id="element-133" data-mp="2jj63ze5jq4vq" />
    </svg>;
}
export function InstagramIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-134" data-mp="2oir43rwgcja1">
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" data-id="element-135" data-mp="2xhcv8bfzp6mf" />
      <circle cx="12" cy="12" r="4" data-id="element-136" data-mp="2xhw0osoge2jk" />
      <circle cx="17" cy="7" r="0.9" fill="currentColor" stroke="none" data-id="element-137" data-mp="lu10h9z8bakh" />
    </svg>;
}
export function ClockIcon({
  className = 'w-5 h-5'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-138" data-mp="gxakemnfcez2">
      <circle cx="12" cy="12" r="8.5" data-id="element-139" data-mp="cvfibfxo5xk8" />
      <path d="M12 7v5.2l3.2 2" strokeLinecap="round" data-id="element-140" data-mp="7v9q9ynhm91m" />
    </svg>;
}
export function ShieldIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-141" data-mp="14mv7nhqm1ye5">
      <path d="M12 3 4.5 6v6c0 4.2 3 7.3 7.5 9 4.5-1.7 7.5-4.8 7.5-9V6L12 3Z" strokeLinejoin="round" data-id="element-142" data-mp="vsgq18ilybrv" />
      <path d="m8.8 12 2.2 2.2 4.2-4.4" strokeLinecap="round" strokeLinejoin="round" data-id="element-143" data-mp="qtdo3wxxclo4" />
    </svg>;
}
export function StarIcon({
  className = 'w-4 h-4'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-144" data-mp="1oaudce6bifcp">
      <path d="m12 2.8 2.6 6.1 6.6.5-5 4.3 1.5 6.5L12 16.7 6.3 20.2l1.5-6.5-5-4.3 6.6-.5L12 2.8Z" data-id="element-145" data-mp="1jfybynf6yfmx" />
    </svg>;
}
export function DiamondIcon({
  className = 'w-4 h-4'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-146" data-mp="182wosa8e4djr">
      <path d="M12 2.5 21.5 12 12 21.5 2.5 12 12 2.5Z" strokeLinejoin="round" data-id="element-147" data-mp="u46pcny3m1s8" />
    </svg>;
}
export function BeardIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-148" data-mp="1mr189gf9ot3l">
      <path d="M5.5 4.5h13v6.5c0 4.7-2.9 8.5-6.5 8.5S5.5 15.7 5.5 11V4.5Z" strokeLinejoin="round" data-id="element-149" data-mp="1qu7amcz9e04s" />
      <path d="M9 10.5h.01M15 10.5h.01" strokeLinecap="round" data-id="element-150" data-mp="1cylp4fs8hyh4" />
      <path d="M9.6 14.5c1.5.9 3.3.9 4.8 0" strokeLinecap="round" data-id="element-151" data-mp="1hyrd9lzap2ug" />
    </svg>;
}
export function ChildIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-152" data-mp="2aftweqpndwnn">
      <circle cx="12" cy="7.5" r="4" data-id="element-153" data-mp="2judraq8xq7kw" />
      <path d="M4.5 20.5c0-3.6 3.4-6 7.5-6s7.5 2.4 7.5 6" strokeLinecap="round" data-id="element-154" data-mp="2jtciksfe5x6c" />
      <path d="M8.5 4.8C9.6 3.3 10.8 2.6 12 2.6s2.4.7 3.5 2.2" strokeLinecap="round" data-id="element-155" data-mp="2fsiu9xy1egcx" />
    </svg>;
}
export function SeniorIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-156" data-mp="2olcbi0x1nptf">
      <circle cx="10" cy="5.5" r="3" data-id="element-157" data-mp="20x2ynoht6cef" />
      <path d="M10 8.5c-2.4 0-4 1.6-4 4v3m0 0V21m0-5.5h4.5V21" strokeLinecap="round" strokeLinejoin="round" data-id="element-158" data-mp="20y4ahv6nf2x7" />
      <path d="M17.5 9.5V21M17.5 9.5c-1 0-1.8-.8-1.8-1.8" strokeLinecap="round" data-id="element-159" data-mp="1wwsn7wb8yts6" />
    </svg>;
}
export function BrowIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-160" data-mp="25ttc0428atw5">
      <path d="M3.5 9.5c2.6-2.6 5.2-3.9 7.8-3.9 2.6 0 5.1 1.3 7.5 3.9" strokeLinecap="round" data-id="element-161" data-mp="3mb7b6eefycmm" />
      <path d="M4.5 15.5c2.5 2.4 5 3.6 7.5 3.6s5-1.2 7.5-3.6" strokeLinecap="round" data-id="element-162" data-mp="3hcdvcfbom9ja" />
      <circle cx="12" cy="15.6" r="1.6" data-id="element-163" data-mp="3papm0kgyxx9q" />
    </svg>;
}
export function EarIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-164" data-mp="269p00l9xnzv">
      <path d="M7 9.5a5 5 0 1 1 10 0c0 3-2.6 3.9-3.6 5.6-.7 1.2-.4 3.4-2.6 3.4-1.5 0-2.4-1-2.4-2.3" strokeLinecap="round" strokeLinejoin="round" data-id="element-165" data-mp="75w4kgokrgbu" />
      <path d="M10.4 9.6a1.7 1.7 0 0 1 3.4 0c0 1.6-2 1.9-2 3.4" strokeLinecap="round" data-id="element-166" data-mp="3am2uzlhzbh2o" />
    </svg>;
}
export function NoseIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-167" data-mp="3fj311wetwjts">
      <path d="M13.5 3v5.2c0 2 1.4 3.3 2.4 4.6 1.1 1.5.6 3.6-1.4 3.6" strokeLinecap="round" strokeLinejoin="round" data-id="element-168" data-mp="3kdpc1yh00adc" />
      <path d="M8 16.4c1.2 1.6 2.9 2.4 4.6 2.4 1.4 0 2.6-.4 3.6-1.2" strokeLinecap="round" data-id="element-169" data-mp="2rvbr2zgrgivo" />
      <path d="M8 16.4c-1.4-.6-1.9-1.7-1.4-2.6" strokeLinecap="round" data-id="element-170" data-mp="2kbsozavtryx8" />
    </svg>;
}
export function ColorIcon({
  className = 'w-6 h-6'
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="none" strokeWidth={1.2} className={`${base} ${className}`} aria-hidden="true" data-id="element-171" data-mp="2fdr4clir3rjn">
      <path d="M12 3.2s5.5 5.7 5.5 9.3a5.5 5.5 0 0 1-11 0C6.5 8.9 12 3.2 12 3.2Z" strokeLinejoin="round" data-id="element-172" data-mp="2afpnm78ss4bc" />
      <path d="M9.4 13.4a2.7 2.7 0 0 0 2.6 3.4" strokeLinecap="round" data-id="element-173" data-mp="21d80zrp8d9nt" />
    </svg>;
}